import { W as WuiIcon$1, d as defineCustomElement$1 } from './p-C78HRAnj.js';

const WuiIcon = WuiIcon$1;
const defineCustomElement = defineCustomElement$1;

export { WuiIcon, defineCustomElement };
